<template>
	<div class="content-box-wrapper login-box content-box-padding">
		<div class="content-box-header bg-gradient-17">
			<h2 class="content-box-header__headline text-white text-center">
				Glömt lösenord
			</h2>
		</div>
		<div class="content-box-wrapper content-box-padding-sm">
			<p>
				Ange din mejladress nedan så skickar vi ett mejl med
				instruktioner för hur du återställer ditt lösenord till din
				mejladress. Vill du logga in?
				<a href="#" @click.prevent="$store.commit('sidebar', 'login')"
					>Klicka här för att logga in.</a
				>
			</p>

			<form action="" @submit.prevent="">
				<div class="form-group">
					<label>Din mejladress</label>
					<input
						type="email"
						v-model="email"
						placeholder="Din e-mail"
						name="email"
						required
					/>
				</div>
				<div class="form-group margin-top-xs-2">
					<input
						type="submit"
						class="pem-btn pem-btn-primary
					pem-btn-block"
						value="Återställ"
						:class="{ 'loading loading-icon-white': isLoading }"
						@click.prevent="doForgotPassword"
					/>
				</div>
			</form>

			<Message
				v-for="message in messages"
				:text="message.text"
				:type="message.type"
				:key="message.text"
			/>

			<div class="margin-top-xs-2">
				<div class="row justify-content-between">
					<div class="col-auto">
						<a
							href="#"
							@click.prevent="$store.commit('sidebar', 'signup')"
							>Skapa konto</a
						>
					</div>
					<div class="col text-right">
						<a
							href="#"
							@click.prevent="$store.commit('sidebar', 'login')"
							>Logga in</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Message from "./../partials/Message.vue";
export default {
	name: "LoginBox",
	props: [],
	components: { Message },
	computed: {
		messages() {
			return this.$store.state.messages.sidebar;
		},
		isLoading() {
			return this.$store.state.isLoading;
		}
	},
	data() {
		return {
			email: ""
		};
	},
	methods: {
		doForgotPassword() {
			if (this.isLoading) return;
			this.$store.dispatch("doForgotPassword", {
				email: this.email
			});
		}
	},
	created() {},
	mounted() {}
};
</script>